
				var addMethods = require("../../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["computeSchedule"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "0bd293a31a450b068b34.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			